import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { Subscriber, Strip, StripDetails, TmpValues } from "src/classes/Customers/Subscriber";
import { Menu } from "primeng/menu";
import { PopupItem } from "src/classes/Common/PopupItem";
import { MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { screenId } from "src/environments/environment";
import { ServiceSubscriber } from "src/classes/Customers/ServiceSubscriber";
import { Worker } from "src/classes/Common/Worker";
import { CommonFunctions } from "src/app/helper/CommonFunctions";
import { SetValid } from "src/classes/Common/SetValid";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { ControlsService } from "src/app/services/Common/controls.service";
import { Config } from "src/classes/Common/ConfigData";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { NGXLogger } from "ngx-logger";
import * as moment from "moment";
import { NgModel } from "@angular/forms";

@Component({
    selector: "app-custcardview44",
    templateUrl: "./custcardview44.component.html",
    styleUrls: ["./custcardview44.component.css"],
    providers: [HttpServiceCustomer, CommonFunctions, MessageService]
})
export class Custcardview44Component implements OnInit, OnDestroy {
    @Input() customerId: number = 0;

    subscriber: Subscriber;
    customerin: CustomerIn = new CustomerIn();
    receivedvalid: SetValid = new SetValid();
    state: string = "loading";
    cols: any[];
    lockedCols: any[];
    mobileCols: any[];
    multi: StripDetails[][] = [[], []];
    multivalues: TmpValues[][] = [[], []];
    tmpStrip: Strip[] = [];
    config: Config = new Config();

    previousTab: number = 0;

    openedMenu: Menu;
    items: ExtendedMenuItem[];
    items_1: ExtendedMenuItem[];
    items_2: ExtendedMenuItem[];
    customClassificationSubscriber: string[] = ["הכל", "פעילים", "הסתיימו"];
    classificationOption: string = "הכל";
    stripId: number = 0;
    stripDetailsId: number = 0;
    isSubscriberMenuOpened: boolean = false;
    isVisitMenuOpened: boolean = false;

    subscribersList: ServiceSubscriber[] = [];
    workers: Worker[] = [];

    isAddingOrEditingSubscriber: number = 0;
    activeIndex: number = 0;
    editedStrip: Strip;
    subscriberOption: string;
    subscriberOptionError: boolean = false;
    workerOption: string;
    newSubscriberAmount: number;
    newSubscriberCloseDate: string | Date;
    closeDateError: boolean = false;
    newSubscriberCardId: string;
    newSubscriberSum: string;
    isDateLimited: boolean;
    saveDisabled: boolean = false;

    isEditingVisit: boolean = false;
    editedVisit: StripDetails;
    newVisitInd: number;
    newVisitIsShrOn: boolean = true;
    newVisitWorker: string;
    newVisitDate: string | Date;
    visitDateError: boolean = false;
    newVisitJoul: string;
    newVisitMS: string;
    newVisitHairType: string;
    newVisitSkinType: string;
    newVisitTypeHandle: string;
    newVisitComments: string;

    isDeletingSubscriber: boolean = false;
    isDeletingVisit: boolean = false;

    minDate: Date = new Date();
    minVisitDate: Date = new Date(this.minDate.getFullYear() - 100, this.minDate.getMonth(), this.minDate.getDate());

    saveData: boolean = false;
    componentHasChanged: boolean = false;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    dialogTitle: string = '';


    /*  isDisabledMenuItem = {
         8: 60,
         10: 63,
         11: 61,
         12: 64,
         13: 65,
     } */

    // isDisabledMenuItem: any[];

    @ViewChild("newSubscriberCloseDateModel", { static: false }) newSubscriberCloseDateModel: NgModel;
    @ViewChild("newVisitDateModel", { static: false }) newVisitDateModel: NgModel;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private commonFunc: CommonFunctions,
        private custCardTabService: CustCardTabService,
        private dynamicDialogService: DynamicDialogService,
        private messageService: MessageService,
        private controlsService: ControlsService,
        private logger: NGXLogger
    ) {
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onTabChange(tabIndex));
    }

    ngOnInit(): void {
        enum MenuEnum {
            FirstMenu,
            SecondMenu
        }

        this.minDate.setDate(this.minDate.getDate() + 1);
        this.customerin.customer_id = this.customerId;

        // Get subscribers data
        this.httpServiceCustomer.getSubscriber(this.customerin)
            .subscribe((res: Subscriber) => {
                this.subscriber = res;

                this.sortSubscribers();

                if (this.subscriber.lststrip.length == 0) {
                    this.state = "nosubscribers";
                }
                else {
                    this.state = "loaded";
                }
                console.log("count of subscribers:" + this.subscriber.lststrip.length);
                console.log(this.subscriber)
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get the list of items in popup
        this.httpServiceCustomer.getItemsMenuByScreen({ screen_id: screenId.Customers.custcardview })
            .subscribe((res: [PopupItem]) => {
                let m: ExtendedMenuItem[] = [];

                // // dynamically retrieving menu lines that should be checked for the user's role
                // this.isDisabledMenuItem = res.filter(item => 
                //     item.cb_id_disable != -1 && (item.mn_menu_id == MenuEnum.FirstMenu || item.mn_menu_id == MenuEnum.SecondMenu)
                // ).map(item => ({
                //     mn_id: item.mn_id,
                //     cb_id_disable: item.cb_id_disable,
                // }));

                res.forEach((item) => {
                    const menuItem: ExtendedMenuItem = {
                        label: item.mn_menuitem_title,
                        icon: item.mn_icon.split(".svg")[0],
                        menu_Id: item.mn_menu_id,
                        // disabled: this.isDisabledMenuItem[item.mn_id] ? this.isDisabled(this.isDisabledMenuItem[item.mn_id]) : false,

                        // changed the "disabled" attribute to a specific value in res
                        disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                        command: () => this.menuItemCommand(item.mn_menu_id, item.mn_order_id)
                    };

                    m.push(menuItem);
                });

                this.items = m;
                this.items_1 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.FirstMenu);
                this.items_2 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.SecondMenu);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get subscribers list
        this.httpServiceCustomer.getServicesSubscriber(this.customerin)
            .subscribe((res: ServiceSubscriber[]) => {
                this.subscribersList = res;

                this.subscribersList.unshift({
                    name: "\0",
                    avodaId: 0,
                })

                this.subscribersList.forEach((x) => {
                    x.label = x.name;
                    x.value = x.name;
                });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get workers list
        this.httpServiceCustomer.getWorkers()
            .subscribe((res: Worker[]) => {
                this.workers = res;

                this.workers.shift();
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Table columns for isShrOn == true
        this.cols = [
            // { field: "",header: "", headerClass: "small-cell"},
            { field: "ind", header: "#", headerClass: "small-cell" },
            { field: "dateVisitStr", header: "תאריך", headerClass: "medium-cell" },
            { field: "joul", header: "גיאול", headerClass: "medium-cell" },
            { field: "ms", header: "עוצמה", headerClass: "medium-cell" },
            { field: "hairType", header: "סוג שיער", headerClass: "medium-cell" },
            { field: "skinType", header: "גוון שער", headerClass: "medium-cell" },
            { field: "typeHandle", header: "סוג הידית", headerClass: "medium-cell" },
            { field: "saparName", header: "שם מטפל", headerClass: "medium-cell" },
            { field: "comments", header: "הערות", headerClass: "large-cell" }
            // { field: "",header: "", headerClass: "small-cell"},
        ];

        // Table columns for isShrOn == false
        this.lockedCols = [
            { field: "ind", header: "#", headerClass: "small-cell" },
            { field: "dateVisitStr", header: "תאריך", headerClass: "medium-cell" },
            { field: "saparName", header: "שם מטפל", headerClass: "medium-cell" },
            { field: "comments", header: "הערות", headerClass: "large-cell" }
        ];


        // Get business configuration
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

    }

    ngOnDestroy(): void {
        this.custCardTabService.tabIndex = 57;
        this.dynamicDialogService.closeDialog();
        this.saveSubscribers();
    }

    onTabChange(tabIndex: number): void {
        // Handle tab change event here
        if (tabIndex == 44) {
            this.saveData = false;
        }

        if (this.previousTab == 44) {
            this.dynamicDialogService.closeDialog();
            this.saveSubscribers();
        }
        this.previousTab = tabIndex;
    }

    onRowExpand(event: any) {
        // Handle row expansion event here
        this.multi[event.data.avodaInd] = event.data.lststripdetails.slice().reverse();

        console.log("multi: ", this.multi[event.data.avodaInd]);

        let tmpval: TmpValues = new TmpValues();
        tmpval.sumtmp = event.data.sum;
        tmpval.saparNamePurchasetmp = event.data.saparNamePurchase;
        tmpval.cardIdtmp = event.data.cardId;
        this.multivalues[0][event.data.avodaInd] = tmpval;

        console.log("Row expanded:", event);
    }

    // Function that opens a modal for adding a new subscriber
    addSubscriber() {
        this.isAddingOrEditingSubscriber = 1;
        this.dialogTitle = "פתיחת מנוי";
        this.subscriberOption = this.subscribersList[0].name.trim();
        this.workerOption = this.workers[0].saparName.trim();
        this.newSubscriberAmount = 10;
        this.newSubscriberCloseDate = "";
        this.newSubscriberCardId = "";
        this.newSubscriberSum = "";
        this.isDateLimited = false;
        this.activeIndex = 1;
    }

    // Function that closes all modals
    cancelButton(): void {
        this.isAddingOrEditingSubscriber = 0;
        this.dialogTitle = "";
        this.isEditingVisit = false;
        this.isDeletingSubscriber = false;
        this.isDeletingVisit = false;
    }

    // Delete subscriber function
    deleteSubscriber(): void {
        let tmpStrip: Strip = this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId);
        let subscriberName: string = tmpStrip.subscriberTypeCalc.split(tmpStrip.subscriberLabel + " ")[1];

        // if (tmpStrip.isVisibleUseSubsBtn) {
        if (this.subscriber.lststrip.length != 1) {
            this.subscribersList.push({
                label: subscriberName,
                name: subscriberName,
                value: subscriberName,
                avodaId: tmpStrip.avodaId,
            });
            this.subscribersList.sort((a, b) => a.avodaId - b.avodaId);
            this.subscriber.lststrip = this.subscriber.lststrip.filter((x) => x.avodaInd != this.stripId);
            this.sortSubscribers();
        }
        else {
            this.subscriber.lststrip[0].lastDeleted = true;
        }

        if (this.subscriber.lststrip.length == 0 || this.subscriber.lststrip[0].lastDeleted) {
            this.state = "nosubscribers";
        }

        this.showMessage("success", "מנוי נמחק בהצלחה.");
        // }
        // else {
        //     this.showMessage("error", "לא ניתן למחוק ניצול של מנוי שהסתיים.");
        // }

        this.isDeletingSubscriber = false;
    }

    // Function of adding a new subscriber
    saveNewSubscriber(typeSubs: number): void {
        let isValid: boolean = true;

        let striptmp: Strip = new Strip();

        let random = Math.floor(Math.random() * (999999 - 100000)) + 100000;
        console.log("random:", random);

        let newSubscriberCloseDate: string | Date = this.newSubscriberCloseDate;

        if (typeof newSubscriberCloseDate == "string" && newSubscriberCloseDate != "") {
            newSubscriberCloseDate = moment(newSubscriberCloseDate as string, "DD/MM/YYYY").toDate();
        }
        else if (newSubscriberCloseDate == "") {
            newSubscriberCloseDate = null;
        }

        let closeDateTmp: string = this.commonFunc.dateToString(newSubscriberCloseDate as Date);

        let openDateTmp: string = this.commonFunc.dateToString(new Date());

        striptmp.avodaId = this.subscribersList.find((x) => x.name.trim() == this.subscriberOption).avodaId;
        striptmp.customerId = this.customerin.customer_id;
        striptmp.typeSubs = typeSubs;
        striptmp.openDate = openDateTmp;
        striptmp.openDateStr = openDateTmp;
        striptmp.saparId = this.workers.find((x) => x.saparName.trim() == this.workerOption).saparId;
        striptmp.saparIdPurchase = this.workers.find((x) => x.saparName.trim() == this.workerOption).saparId;
        striptmp.saparNamePurchase = this.workerOption;
        striptmp.avodaIndHelp = random;
        striptmp.avodaInd = random;
        striptmp.status = 0;
        striptmp.isShrOn = this.config.isSHROn;
        striptmp.subscriberLabel = "מנוי";
        striptmp.subscriberTypeCalc = striptmp.subscriberLabel + " " + this.subscriberOption;

        if (striptmp.avodaId == 0) {
            isValid = false;
            this.subscriberOptionError = true;
        }
        else {
            this.subscriberOptionError = false;
        }

        if (typeSubs == 1) {
            striptmp.amount = this.newSubscriberAmount;

            if (this.isDateLimited) {
                if (this.newSubscriberCloseDateModel.valid && newSubscriberCloseDate) {
                    striptmp.closeDate = closeDateTmp;
                    striptmp.closeDateStr = closeDateTmp;
                    this.closeDateError = false;
                }
                else {
                    isValid = false;
                    this.closeDateError = true;
                }
            }
        }
        else {
            striptmp.closeDate = closeDateTmp;
            striptmp.closeDateStr = closeDateTmp;

            if (this.newSubscriberCloseDateModel.valid) {
                striptmp.closeDate = closeDateTmp;
                striptmp.closeDateStr = closeDateTmp;
                this.closeDateError = false;

                if (newSubscriberCloseDate) {
                    this.newSubscriberAmount = (newSubscriberCloseDate as Date).getTime() - (new Date()).getTime();
                    this.newSubscriberAmount = Math.round(this.newSubscriberAmount / (1000 * 3600 * 24));

                    if (this.newSubscriberAmount > 99) {
                        this.newSubscriberAmount = 99;
                    }

                    striptmp.amount = this.newSubscriberAmount;
                }
                else {
                    striptmp.amount = 10;
                }
            }
            else {
                isValid = false;
                this.closeDateError = true;
            }

        }

        if (this.newSubscriberSum == "") {
            striptmp.sum = "0";
        }
        else {
            striptmp.sum = this.newSubscriberSum;
        }

        if (this.newSubscriberCardId == "") {
            striptmp.cardId = "0";
        }
        else {
            striptmp.cardId = this.newSubscriberCardId;
        }

        striptmp.lststripdetails = [];
        // this.addNewVisit(striptmp); was before receiving reject about making new subscriber

        // request condition for status strip
        if (striptmp.lststripdetails.length < striptmp.amount) {
            striptmp.status = 0;
            striptmp.isVisibleUseSubsBtn = true;
        }
        else {
            striptmp.status = 1;
            striptmp.isVisibleUseSubsBtn = false;
        }

        if (isValid) {
            this.subscriber.lststrip.unshift(striptmp);
            this.subscriber.lststrip = this.subscriber.lststrip.filter((item: Strip) => item.lastDeleted != true);

            this.state = "loaded";
            this.sortSubscribers();

            this.showMessage("success", "מנוי התווסף בהצלחה");
            this.isAddingOrEditingSubscriber = 0;
            this.dialogTitle = "";
            this.dialogTitle = "";
            this.subscribersList.splice(this.subscribersList.indexOf(this.subscribersList.find((x) => x.name.trim() == this.subscriberOption)), 1);
        }
    }

    // Subscriber editing function
    saveEditedSubscriber(): void {
        if (this.newSubscriberSum == "") {
            this.newSubscriberSum = "0";
        }
        if (this.newSubscriberCardId == "") {
            this.newSubscriberCardId = "-";
        }

        this.subscriber.lststrip.find((x) => x.avodaInd == this.editedStrip.avodaInd).sum = this.newSubscriberSum;
        this.subscriber.lststrip.find((x) => x.avodaInd == this.editedStrip.avodaInd).cardId = this.newSubscriberCardId;

        if (this.multivalues[0][this.editedStrip.avodaInd]) {
            this.multivalues[0][this.editedStrip.avodaInd].sumtmp = this.newSubscriberSum;
            this.multivalues[0][this.editedStrip.avodaInd].cardIdtmp = this.newSubscriberCardId;
        }

        this.showMessage("success", "מנוי עודכן בהצלחה");
        this.sortSubscribers();
        this.isAddingOrEditingSubscriber = 0;
        this.dialogTitle = "";
    }

    // Function of adding a new visit
    addNewVisit(strip: Strip): void {
        let tmpStripDetails: StripDetails[] = [];
        let stripdetail = new StripDetails();

        stripdetail.avodaIndHelp = strip.avodaIndHelp;
        stripdetail.avodaInd = strip.avodaInd;
        stripdetail.customerId = strip.customerId;
        stripdetail.avodaId = strip.avodaId;
        stripdetail.dateVisitStr = this.commonFunc.dateToString(new Date());
        stripdetail.saparName = "ניצול ידני";
        stripdetail.comments = "";
        stripdetail.hairType = "";
        stripdetail.ms = "";
        stripdetail.typeHandle = "";
        stripdetail.joul = "";
        stripdetail.skinType = "";

        // request condition for status stripdetail
        if (stripdetail.dateVisitStr && stripdetail.dateVisitStr != null) {
            stripdetail.status = 1;
        }
        else {
            stripdetail.status = 0;
        }

        if (strip.lststripdetails.length) {
            stripdetail.ind = strip.lststripdetails.length + 1;

            strip.lststripdetails.push(stripdetail);
        }
        else {
            stripdetail.ind = 1;

            tmpStripDetails.push(stripdetail);
            strip.lststripdetails = tmpStripDetails;
        }

        if (this.multi[strip.avodaInd]) {
            this.multi[strip.avodaInd].unshift(stripdetail);
        }

        if (strip.lststripdetails.length >= strip.amount) {
            strip.status = 1;
            strip.isVisibleUseSubsBtn = false;
            this.sortSubscribers();
        }

        this.showMessage("success", "ניצול התווסף בהצלחה");
    }

    // Visit editing function
    saveEditedVisit(): void {
        let newVisitDate: string | Date = this.newVisitDate;

        if (typeof newVisitDate == "string" && newVisitDate != "") {
            newVisitDate = moment(newVisitDate as string, "DD/MM/YYYY").toDate();
        }

        if (this.newVisitDateModel.valid && newVisitDate) {
            this.visitDateError = false;
        }
        else {
            this.visitDateError = true;
        }

        let stripdetail = new StripDetails();

        stripdetail.avodaIndHelp = this.editedVisit.avodaIndHelp;
        stripdetail.avodaInd = this.editedVisit.avodaInd;
        stripdetail.ind = this.editedVisit.ind;
        stripdetail.customerId = this.editedVisit.customerId;
        stripdetail.avodaId = this.editedVisit.avodaId;
        stripdetail.dateVisitStr = this.commonFunc.dateToString(newVisitDate as Date);
        stripdetail.saparName = this.editedVisit.saparName;
        stripdetail.saparid = this.editedVisit.saparid;
        stripdetail.comments = this.newVisitComments;
        stripdetail.hairType = this.newVisitHairType;
        stripdetail.ms = this.newVisitMS;
        stripdetail.typeHandle = this.newVisitTypeHandle;
        stripdetail.joul = this.newVisitJoul;
        stripdetail.skinType = this.newVisitSkinType;

        if (stripdetail.dateVisitStr && stripdetail.dateVisitStr != null) {
            stripdetail.status = 1;
        }
        else {
            stripdetail.status = 0;
        }

        if (!this.visitDateError) {
            let tmpStripDetails = this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).lststripdetails;

            this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).lststripdetails[tmpStripDetails.indexOf(
                tmpStripDetails.find((x) => x.ind == this.stripDetailsId)
            )] = stripdetail;
            this.multi[this.stripId][tmpStripDetails.length - 1 - tmpStripDetails.indexOf(
                tmpStripDetails.find((x) => x.ind == this.stripDetailsId)
            )] = stripdetail;

            this.showMessage("success", "ניצול עודכן בהצלחה");
            this.isEditingVisit = false;
        }
    }

    // Visit deleting function
    deleteVisit(): void {
        this.multi[this.stripId] = this.multi[this.stripId].filter((x) => x.ind != this.stripDetailsId);
        this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).lststripdetails = this.subscriber.lststrip.find(
            (x) => x.avodaInd == this.stripId
        ).lststripdetails.filter((x) => x.avodaInd == this.stripId && x.ind != this.stripDetailsId);

        this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).lststripdetails.forEach((item, index) => {
            item.ind = index + 1;
        });

        this.isDeletingVisit = false;
        this.showMessage("success", "ניצול נמחק בהצלחה.");
    }

    decrementAmount(): void {
        if (this.newSubscriberAmount > 1) {
            this.newSubscriberAmount--;
        }
    }

    incrementAmount(): void {
        if (this.newSubscriberAmount < 100) {
            this.newSubscriberAmount++;
        }
    }

    // Function of limiting the input of values in the input field
    onInputChange(model: string, eventTarget: HTMLInputElement): void {
        this[model] = this[model].replace(/[^0-9*#]/g, "");
        eventTarget.value = this[model];
    }

    onRangeFocus(target: HTMLInputElement): void {
        target.select();
    }

    // Function of limiting the input of values in the range field
    onRangeChange(model: string, eventTarget: HTMLInputElement, minValue?: number, maxValue?: number): void {
        this[model] = +this[model].replace(/[^0-9*#]/g, "");

        if (minValue && this[model] < minValue) {
            this[model] = minValue;
        }
        if (maxValue && this[model] > maxValue) {
            this[model] = maxValue;
        }

        eventTarget.value = this[model];
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    // Subscriber filtering function
    filterDataSubscriber() {
        if (this.classificationOption !== "הכל") {
            const classificationindex = this.customClassificationSubscriber.indexOf(this.classificationOption);
            let statussubscriber;

            if (classificationindex === 1) {
                statussubscriber = 0;
            }

            if (classificationindex === 2) {
                statussubscriber = 1;
            }

            this.tmpStrip = this.subscriber.lststrip.filter((x) => x.status === statussubscriber);
        }
        else {
            this.sortSubscribers();
        }

        if (this.tmpStrip.length == 0) {
            this.state = "nosubscribers";
        }
        else {
            this.state = "loaded";
        }
    }

    // Strip menu toggle function
    toggleSubMenu(event: PointerEvent, menu: Menu, ind: number, isMobile: boolean): void {
        if (isMobile) {
            this.isSubscriberMenuOpened = true;
            this.stripId = ind;
        }
        else {
            menu.toggle(event);
            console.log("Strip: " + ind);
            this.stripId = ind;
            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    // Substrip menu toggle function
    toggleSubMenuDetails(event: PointerEvent, menu: Menu, ind: number, avodaind: number, isMobile: boolean): void {
        if (isMobile) {
            this.isVisitMenuOpened = true;
            this.stripDetailsId = ind;
            this.stripId = avodaind;
        }
        else {
            menu.toggle(event);
            console.log("StripDetails: " + ind);
            this.stripDetailsId = ind;
            this.stripId = avodaind;
            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    // Commands for menu items by their id
    menuItemCommand(menu_id: number, order_id: number): void {
        if (menu_id == 0 && order_id == 1) {
            this.isAddingOrEditingSubscriber = 2;
            this.dialogTitle = "עריכת מנוי";
            this.isSubscriberMenuOpened = false;
            this.editedStrip = this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId);
            this.activeIndex = this.editedStrip.typeSubs == 2 ? 0 : 1;

            let date = this.commonFunc.stringToDate(this.editedStrip.closeDate);

            this.workerOption = this.editedStrip.saparNamePurchase;
            this.newSubscriberAmount = this.editedStrip.amount;
            this.newSubscriberCloseDate = date;
            this.newSubscriberCardId = this.editedStrip.cardId;
            this.newSubscriberSum = this.editedStrip.sum;
            this.subscriberOption = this.editedStrip.subscriberTypeCalc;
        }
        else if (menu_id == 0 && order_id == 3) {
            this.isDeletingSubscriber = true;
            this.isSubscriberMenuOpened = false;
        }
        else if (menu_id == 1 && order_id == 1) {
            this.isEditingVisit = true;
            this.isVisitMenuOpened = false;
            this.editedVisit = this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).lststripdetails.find((x) => x.ind == this.stripDetailsId);

            let date = this.commonFunc.stringToDate(this.editedVisit.dateVisitStr);

            this.newVisitInd = this.editedVisit.ind;
            this.newVisitDate = date;
            this.newVisitComments = this.editedVisit.comments;
            this.newVisitHairType = this.editedVisit.hairType;
            this.newVisitIsShrOn = this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).isShrOn;
            this.newVisitJoul = this.editedVisit.joul;
            this.newVisitMS = this.editedVisit.ms;
            this.newVisitSkinType = this.editedVisit.skinType;
            this.newVisitTypeHandle = this.editedVisit.typeHandle;
            this.newVisitWorker = this.editedVisit.saparName;
        }
        else if (menu_id == 1 && order_id == 2) {
            this.isVisitMenuOpened = false;
            if (this.subscriber.lststrip.find((x) => x.avodaInd == this.stripId).isVisibleUseSubsBtn == false) {
                this.showMessage("error", "לא ניתן למחוק ניצול של מנוי שהסתיים");
            }
            else {
                this.isDeletingVisit = true;
            }
        }
    }

    // Function to sort subscribers by isVisibleUseSubsBtn and openDateStr fields
    sortSubscribers(): void {
        this.tmpStrip = this.subscriber.lststrip.slice().sort((item1, item2) => {
            return (this.commonFunc.stringToDate(item2.openDateStr).getTime() - this.commonFunc.stringToDate(item1.openDateStr).getTime());
        }).sort((item1, item2) => {
            return (item1.isVisibleUseSubsBtn === item2.isVisibleUseSubsBtn) ? 0 : item1.isVisibleUseSubsBtn ? -1 : 1;
        });
    }

    // Function of saving changes
    saveSubscribers(): void {
        if (this.componentHasChanged) {
            this.saveData = true;
            this.httpServiceCustomer.setSubscriber(this.subscriber)
                .then((res: SetValid) => {
                    this.receivedvalid = res;
                    this.receivedvalid.answer = res.answer;
                    console.log("CastCard_44 data saved: " + this.receivedvalid.answer);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }
}
